module.exports = __webpack_public_path__ + "media/appmovie.ea326390.mp4";